module.exports = __webpack_public_path__ + "static/viewport-0434788c7505a4d59919eb796f9644bc.mp4";